export const MuiFormControl = {
	styleOverrides: {
		root: {
			"& .Mui-disabled": {
				backgroundColor: "transparent",
			},
		},
	},
};
